import React, { useState, useEffect } from 'react';
import './GreenPlazaModal.css';

const highlights = [
  { icon: '🔑', title: 'Ready to Move', desc: 'Immediate possession available' },
  { icon: '📍', title: 'Prime Location', desc: 'Sector 16B, Near 1 Murti Chowk' },
  { icon: '🏠', title: 'Studio Apartments', desc: '1st, 2nd & 3rd Floor' },
  { icon: '🏪', title: 'Retail Shops', desc: 'Ground & Upper Ground Floor' },
  { icon: '📈', title: 'Rental from Day 1', desc: 'Assured ₹40/sq.ft Monthly*' },
  { icon: '🏦', title: 'Home Loan', desc: 'Loan facility available' },
  { icon: '🏗️', title: 'Commercial + Residential', desc: 'Unique mixed-use concept' },
  { icon: '🛣️', title: '60 Meter Wide Road', desc: 'High visibility & footfall' },
  { icon: '💰', title: 'Low Ticket Investment', desc: 'Starting ₹23.09 Lacs*' },
  { icon: '👥', title: 'High Rental Demand', desc: 'Prime commercial zone' },
];

const studioUnits = [
  { size: '330', price: '₹23,09,670', rent: '₹13,200/month*', type: 'Studio Apartment' },
  { size: '360', price: '₹25,19,640', rent: '₹14,400/month*', type: 'Studio Apartment' },
  { size: '375', price: '₹26,24,625', rent: '₹15,000/month*', type: 'Studio Apartment' },
];

const masterUnits = [
  { size: '450', price: '₹31,49,550', rent: '₹18,000/month*', type: 'Master Suite' },
  { size: '525', price: '₹36,74,475', rent: '₹21,000/month*', type: 'Master Suite' },
  { size: '725', price: '₹50,74,275', rent: '₹29,000/month*', type: 'Master Suite' },
];

const retailUnits = [
  { size: '192', price: '₹23.90 Lacs*', floor: 'Ground / Upper Ground' },
  { size: '355', price: '₹48.49 Lacs*', floor: 'Ground / Upper Ground' },
  { size: '365', price: '₹49.90 Lacs*', floor: 'Ground / Upper Ground' },
];

const locationPoints = [
  { dist: '2.5 km', place: '1 Murti Chowk' },
  { dist: '2.5 km', place: 'Upcoming Metro Station' },
  { dist: '4 km', place: 'Gaur City Mall' },
  { dist: '4 km', place: 'Ghaziabad' },
  { dist: '10 km', place: 'Sector 62' },
  { dist: '10 km', place: 'Sec 51 Metro Station' },
];

const specifications = [
  {
    icon: '🪵', title: 'Flooring & Wall Tiles',
    points: ['Vitrified tile flooring in Room, Hall & Kitchen', 'Ceramic tiles in Balcony and Bathroom'],
  },
  {
    icon: '🎨', title: 'Wall & Ceiling Finishes',
    points: ['Gypsum plaster on wall & ceiling', 'Plastic paint / wallpaper on wall & ceiling'],
  },
  {
    icon: '🚪', title: 'Doors & Windows',
    points: ['MS door frame (front door double patam)', 'UPVC outer door & window', 'Good quality hardware fittings', 'MS railing in balcony'],
  },
  {
    icon: '⚡', title: 'Electrical',
    points: ['Copper wire in PVC conduit with MCB supported circuit', 'Modular switches with switch plates'],
  },
];

const furnishingItems = [
  'Wardrobe in Bedroom', 'Modular Woodwork in Kitchen', 'White Sanitary Ware in Bathroom',
  'CP Fittings in Bathroom & Kitchen', 'Mirror in Bathroom', 'Counter Wash Basin in Bathroom',
  'Fan & Light in Bedroom & Hall', 'Exhaust Fan in Bathroom', 'One Double Bed',
  '32" TV with TV Console', 'Split AC (1.0 Ton) – 1 Outdoor & 1 Indoor', 'One Geyser – 10 Litres',
  'One Refrigerator – 45 Litres', 'Chimney', 'RO & Sink in Kitchen', 'Gas Stove',
];

const tabs = ['Overview', 'Units & Pricing', 'Retail Shops', 'Location', 'Specifications', 'Contact'];

export default function GreenPlazaModal({ onClose }) {
  const [activeTab, setActiveTab] = useState('Overview');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  return (
    <div className="gp-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="gp-modal">

        {/* ── HERO ── */}
        <div className="gp-hero">
          <img
            src="image/Greenparadise.jpg"
            alt="Paradise Greens Plaza"
            className="gp-hero-img"
          />
          <div className="gp-hero-overlay" />
          <button className="gp-close" onClick={onClose} aria-label="Close">
            <i className="fa fa-times" />
          </button>
          <div className="gp-hero-content">
            <div className="gp-tagline-top">Luxurious Living</div>
            <div className="gp-brand">
              <span>PARADISE</span>
              <span className="gp-brand-sub">GREENS PLAZA</span>
            </div>
            <p className="gp-sub">Studio Apartments & Retail Shops · Sector 16B, Near 1 Murti Chowk, Noida Extension</p>
            <div className="gp-hero-pills">
              <span className="gp-pill ready">🔑 Ready to Move</span>
              <span className="gp-pill prime">📍 Prime Location</span>
              <span className="gp-pill rental">📈 Assured Rental</span>
              <span className="gp-pill limited">⚡ Few Units Left</span>
            </div>
            <div className="gp-price-bar">
              <div className="gp-price-cell">
                <span>Starting From</span>
                <strong>₹23.09 Lacs*</strong>
              </div>
              <div className="gp-price-sep" />
              <div className="gp-price-cell">
                <span>Assured Rental</span>
                <strong>₹40 / sq.ft</strong>
              </div>
              <div className="gp-price-sep" />
              <div className="gp-price-cell">
                <span>Sales & Inventory</span>
                <strong>747-747-1006</strong>
              </div>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="gp-tabs">
          {tabs.map(t => (
            <button
              key={t}
              className={`gp-tab ${activeTab === t ? 'active' : ''}`}
              onClick={() => setActiveTab(t)}
            >{t}</button>
          ))}
        </div>

        <div className="gp-body">

          {/* OVERVIEW */}
          {activeTab === 'Overview' && (
            <div className="gp-section">
              <div className="gp-navy-tag">Paradise Group NCR · Your Dream. Your Paradise.</div>
              <h2>Project Highlights</h2>
              <p className="gp-section-sub">
                A unique <strong>Commercial + Residential</strong> mixed-use development — India's smartest investment at Noida Extension's prime address.
              </p>

              <div className="gp-highlights-grid">
                {highlights.map((h, i) => (
                  <div className="gp-hl-card" key={i}>
                    <div className="gp-hl-icon">{h.icon}</div>
                    <div>
                      <div className="gp-hl-title">{h.title}</div>
                      <div className="gp-hl-desc">{h.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="gp-urgency-banner">
                <div className="gp-urgency-left">
                  <div className="gp-urgency-badge">⚡ FEW UNITS LEFT</div>
                  <h3>HIGH DEMAND. LOW SUPPLY.</h3>
                  <p>Don't miss your chance. Book before it's gone.</p>
                </div>
                <div className="gp-urgency-right">
                  <div>
                    <strong>LIMITED INVENTORY</strong>
                    <span>Ready to Move Studio Apartments</span>
                  </div>
                  <button className="gp-book-btn">
                    <i className="fa fa-phone" /> Book Now – 747-747-1006
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* UNITS & PRICING */}
          {activeTab === 'Units & Pricing' && (
            <div className="gp-section">
              <h2>Studio Apartments — Ready to Move</h2>
              <p className="gp-section-sub">1st, 2nd & 3rd Floor · Assured Rental @ ₹40/sq.ft Monthly*</p>

              <div className="gp-unit-section-label studio">
                🏠 Studio Apartments
              </div>
              <div className="gp-units-grid">
                {studioUnits.map((u, i) => (
                  <div className="gp-unit-card" key={i}>
                    <div className="gp-unit-size">{u.size} <small>sq.ft</small></div>
                    <div className="gp-unit-price">{u.price}</div>
                    <div className="gp-unit-rent">
                      <i className="fa fa-calendar-check" /> {u.rent}
                    </div>
                    <div className="gp-unit-type">{u.type}</div>
                    <button className="gp-enquire-unit">Enquire</button>
                  </div>
                ))}
              </div>

              <div className="gp-unit-section-label master">
                👑 Master Suites
              </div>
              <div className="gp-units-grid">
                {masterUnits.map((u, i) => (
                  <div className="gp-unit-card master" key={i}>
                    <div className="gp-unit-size">{u.size} <small>sq.ft</small></div>
                    <div className="gp-unit-price">{u.price}</div>
                    <div className="gp-unit-rent">
                      <i className="fa fa-calendar-check" /> {u.rent}
                    </div>
                    <div className="gp-unit-type">{u.type}</div>
                    <button className="gp-enquire-unit master-btn">Enquire</button>
                  </div>
                ))}
              </div>

              <div className="gp-floor-layout">
                <h3>Floor Layout Overview</h3>
                <div className="gp-floor-cards">
                  <div className="gp-floor-card">
                    <div className="gp-floor-icon">🏢</div>
                    <strong>Ground Floor Plan</strong>
                    <p>Commercial spaces / Retail access. 29ft, 26ft & 30ft wide roads.</p>
                  </div>
                  <div className="gp-floor-card">
                    <div className="gp-floor-icon">🏠</div>
                    <strong>First Floor Plan</strong>
                    <p>Studio apartment planning for modern living.</p>
                  </div>
                  <div className="gp-floor-card">
                    <div className="gp-floor-icon">🏗️</div>
                    <strong>2nd Floor Plan</strong>
                    <p>Studio apartment planning for modern living.</p>
                  </div>
                </div>
              </div>

              <div className="gp-disclaimer-sm">
                *Terms & conditions apply. Assured rental subject to terms mentioned in the agreement.
              </div>
            </div>
          )}

          {/* RETAIL SHOPS */}
          {activeTab === 'Retail Shops' && (
            <div className="gp-section">
              <h2>Ready to Move Retail Shops</h2>
              <p className="gp-section-sub">Ground & Upper Ground Floor · Prime Commercial Spaces</p>

              <div className="gp-retail-table">
                <div className="gp-retail-header">
                  <span>Shop Size</span>
                  <span>Area</span>
                  <span>Starting Price</span>
                  <span></span>
                </div>
                {retailUnits.map((r, i) => (
                  <div className="gp-retail-row" key={i}>
                    <span><i className="fa fa-store" /></span>
                    <span className="gp-retail-area">{r.size} sq.ft</span>
                    <span className="gp-retail-price">{r.price}</span>
                    <button className="gp-retail-btn">Enquire</button>
                  </div>
                ))}
              </div>

              <div className="gp-retail-features">
                <div className="gp-retail-feat">
                  <span className="gp-rf-icon">📍</span>
                  <strong>Prime Commercial Location</strong>
                  <p>60 Meter wide main road frontage</p>
                </div>
                <div className="gp-retail-feat">
                  <span className="gp-rf-icon">👁️</span>
                  <strong>Excellent Visibility</strong>
                  <p>High footfall zone near 1 Murti Chowk</p>
                </div>
                <div className="gp-retail-feat">
                  <span className="gp-rf-icon">👥</span>
                  <strong>Footfall Potential</strong>
                  <p>Residential complex above ensures daily customers</p>
                </div>
                <div className="gp-retail-feat">
                  <span className="gp-rf-icon">📈</span>
                  <strong>Ideal for Investment</strong>
                  <p>Rental from Day 1, high ROI potential</p>
                </div>
              </div>

              <div className="gp-retail-tagline">
                Luxurious Living. Limitless Opportunities.
              </div>
            </div>
          )}

          {/* LOCATION */}
          {activeTab === 'Location' && (
            <div className="gp-section">
              <h2>Location Advantages & Site Map</h2>
              <p className="gp-section-sub">Sector 16B, Near 1 Murti Chowk, Noida Extension — perfectly connected</p>

              <div className="gp-location-grid">
                <div className="gp-loc-list">
                  <h3><i className="fa fa-map-marker-alt" /> Distance Advantage</h3>
                  {locationPoints.map((l, i) => (
                    <div className="gp-loc-item" key={i}>
                      <div className="gp-loc-dist">{l.dist}</div>
                      <div className="gp-loc-place">{l.place}</div>
                    </div>
                  ))}
                </div>

                <div className="gp-loc-map">
                  <iframe
                    title="Paradise Greens Plaza Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.8!2d77.4389!3d28.635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sNoida%20Extension!5e0!3m2!1sen!2sin!4v1699999999"
                    width="100%" height="260"
                    style={{ border: 0, borderRadius: 12 }}
                    allowFullScreen="" loading="lazy"
                  />
                  <div className="gp-map-address">
                    <i className="fa fa-building" />
                    <span>Sector 16B, Near 1 Murti Chowk, Noida Extension</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SPECIFICATIONS */}
          {activeTab === 'Specifications' && (
            <div className="gp-section">
              <div className="gp-spec-title-wrap">
                <h2>Fully Loaded Studio Specifications</h2>
                <div className="gp-spec-subtitle">Premium finishes. Modern comfort. Everything you need.</div>
              </div>

              <div className="gp-specs-grid">
                {specifications.map((s, i) => (
                  <div className="gp-spec-card" key={i}>
                    <div className="gp-spec-header">
                      <span className="gp-spec-emoji">{s.icon}</span>
                      <h4>{s.title}</h4>
                    </div>
                    <ul>
                      {s.points.map((p, j) => (
                        <li key={j}><span className="gp-spec-dot" />  {p}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              <h3 className="gp-furnish-title">🛋️ Furnishing & Other Items Included</h3>
              <div className="gp-furnish-grid">
                {furnishingItems.map((item, i) => (
                  <div className="gp-furnish-item" key={i}>
                    <i className="fa fa-check" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* CONTACT */}
          {activeTab === 'Contact' && (
            <div className="gp-section">
              <h2>Book Your Unit Today</h2>
              <p className="gp-section-sub">Few units left — High demand, Low supply. Don't miss your chance.</p>

              <div className="gp-contact-cards">
                <div className="gp-contact-card">
                  <div className="gp-cc-icon">📞</div>
                  <h4>Sales & Inventory</h4>
                  <p className="gp-cc-main">747-747-1006</p>
                  <p>Call for availability & booking</p>
                </div>
                <div className="gp-contact-card">
                  <div className="gp-cc-icon">📍</div>
                  <h4>Location</h4>
                  <p className="gp-cc-main">Sector 16B</p>
                  <p>Near 1 Murti Chowk, Noida Extension</p>
                </div>
                <div className="gp-contact-card">
                  <div className="gp-cc-icon">🏢</div>
                  <h4>Developer</h4>
                  <p className="gp-cc-main">Paradise Group NCR</p>
                  <p>Your Dream. Your Paradise.</p>
                </div>
                <div className="gp-contact-card">
                  <div className="gp-cc-icon">💰</div>
                  <h4>Starting Price</h4>
                  <p className="gp-cc-main">₹23.09 Lacs*</p>
                  <p>Assured rental from Day 1</p>
                </div>
              </div>

              <div className="gp-final-cta">
                <div className="gp-final-left">
                  <h3>BOOK BEFORE IT'S GONE</h3>
                  <p>Prime Location · Assured Rental · Limited Inventory</p>
                </div>
                <button className="gp-final-btn">
                  <i className="fa fa-phone" /> Call Now: 747-747-1006
                </button>
              </div>

              <div className="gp-disclaimer-sm">
                *Terms & conditions apply. Assured rental subject to terms mentioned in the agreement. All details are subject to change. Please refer to the official agreement before booking.
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
